import React, { useEffect, useRef } from "react";
import "./DailyQuoteModal.css";

/**
 * 하루 처음 들어온 날 뜨는 "오늘의 문장".
 *
 * 다른 독자가 자기 행성에 걸어둔 문장이다. 그래서 문장만 크게 두고
 * 책과 사람은 작게 받친다 — 누가 썼는지보다 문장이 먼저 읽혀야 한다.
 */
export default function DailyQuoteModal({ quote, onClose, onUserClick }) {
  const closeRef = useRef(null);

  useEffect(() => {
    closeRef.current?.focus();
    const onKey = (e) => e.key === "Escape" && onClose();
    window.addEventListener("keydown", onKey);
    return () => window.removeEventListener("keydown", onKey);
  }, [onClose]);

  if (!quote) return null;

  return (
    <div className="dq-overlay" onClick={onClose}>
      <div
        className="dq-modal"
        role="dialog"
        aria-modal="true"
        aria-labelledby="dq-label"
        onClick={(e) => e.stopPropagation()}
      >
        <div id="dq-label" className="dq-label">오늘의 문장</div>

        <blockquote className="dq-quote">
          <span className="dq-mark" aria-hidden="true">“</span>
          {quote.text}
        </blockquote>

        {/* 출처. 누를 수 없게 둔다 — 갈 곳을 하나로 모았다.
            책·사람·나도 걸기 세 갈래가 있으면 문장보다 버튼이 먼저 읽힌다. */}
        <div className="dq-cite">
          『{quote.bookTitle}』{quote.bookAuthor ? ` ${quote.bookAuthor}` : ""}
        </div>

        {/* 하나뿐인 갈 곳: 이 문장을 걸어둔 사람의 '문장' 탭, 이 문장 자리.
            행성 첫 탭(공통·궤적)으로 가면 문장을 보고 눌렀는데 그래프가 나온다. */}
        <button
          className="dq-go"
          onClick={() => { onClose(); if (onUserClick) onUserClick(quote.userId, quote.id); }}
        >
          <span className="dq-go-avatar" aria-hidden="true">{quote.avatar || "🌿"}</span>
          {quote.name}님의 행성으로 가기 →
        </button>

        <button ref={closeRef} className="dq-close" onClick={onClose}>
          닫기
        </button>
      </div>
    </div>
  );
}
